import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { rupiah, dmy } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Hourglass, FileCheck2 } from "lucide-react";

export default function WaitingHpp() {
  const { can } = useAuth();
  const [rows, setRows] = useState(null);
  const load = () => { setRows(null); api.get("/costing/waiting-hpp").then((r) => setRows(r.data)); };
  useEffect(load, []);
  const gen = async (rid) => {
    try { const r = await api.post(`/costing/waiting-hpp/${rid}/generate-cogs`); toast.success(`Jurnal HPP dibuat (${r.data.cogs_journal}) · ${rupiah(r.data.total)}`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div>
      <PageHeader title="Transaksi Menunggu HPP" subtitle="Penjualan SELESAI yang belum punya jurnal HPP karena HPP belum disetujui. Revenue tetap diakui; COGS menyusul." testId="waiting-hpp-header" />
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-x-auto">
        {!rows ? <Loading /> : rows.length === 0 ? <EmptyState title="Tidak ada transaksi menunggu HPP" subtitle="Semua penjualan SELESAI sudah memiliki jurnal HPP atau belum ada penjualan." icon={FileCheck2} /> : (
          <Table>
            <TableHeader><TableRow><TableHead>No Order</TableHead><TableHead>Tanggal</TableHead><TableHead>Toko</TableHead><TableHead>Marketplace</TableHead><TableHead>SKU</TableHead><TableHead className="text-right">Revenue</TableHead><TableHead>SKU Tanpa HPP</TableHead><TableHead>COGS</TableHead><TableHead></TableHead></TableRow></TableHeader>
            <TableBody>{rows.map((r) => (
              <TableRow key={r.receivable_id} data-testid={`waiting-row-${r.order_no}`}>
                <TableCell className="font-mono text-xs">{r.order_no}</TableCell><TableCell className="text-xs text-slate-500">{dmy(r.order_date)}</TableCell>
                <TableCell className="text-xs">{r.store_name || "-"}</TableCell><TableCell className="text-xs">{r.marketplace_name || "-"}</TableCell>
                <TableCell className="text-xs">{(r.skus || []).join(", ")}</TableCell><TableCell className="text-right tabular-nums">{rupiah(r.revenue)}</TableCell>
                <TableCell className="text-xs font-semibold text-amber-600">{(r.missing_hpp_skus || []).join(", ")}</TableCell>
                <TableCell className="text-xs text-rose-600">{r.cogs_status}</TableCell>
                <TableCell className="text-right">{can("costing.cogs.generate") && <Button size="sm" variant="outline" className="h-7 text-xs text-indigo-600" onClick={() => gen(r.receivable_id)} data-testid={`gen-cogs-${r.order_no}`}>Generate Jurnal HPP</Button>}</TableCell>
              </TableRow>))}</TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
